module.exports = require("./mg-MG.js");